import {
    Component,
    Input,
    Output,
    EventEmitter,
    inject,
    ChangeDetectionStrategy,
    OnDestroy,
} from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';

import { AuthService, HeaderContentService } from '../../services';
import { UserPanelComponent } from '../user-panel/user-panel.component';
import { DxButtonComponent } from 'devextreme-angular/ui/button';
import { DxToolbarComponent } from 'devextreme-angular/ui/toolbar';
import * as packageInfo from '../../../../../package.json';
import { ContentReadyEvent } from 'devextreme/ui/toolbar';
import { DxiItemComponent } from 'devextreme-angular/ui/nested';
import { DxTemplateDirective } from 'devextreme-angular/core';

@Component({
    selector: 'app-header',
    templateUrl: 'header.component.html',
    styleUrls: ['./header.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        DxToolbarComponent,
        DxiItemComponent,
        DxTemplateDirective,
        DxButtonComponent,
        UserPanelComponent,
        NgTemplateOutlet,
    ],
})
export class HeaderComponent implements OnDestroy {
    private authService = inject(AuthService);
    headerContent = inject(HeaderContentService);

    private readonly slotObserver = new ResizeObserver(([entry]) =>
        this.headerContent.setSlotWidth(entry.contentRect.width),
    );

    // Re-attached on every render: DevExtreme builds the item elements
    // itself (an Angular view query does not see them) and replaces them when
    // the toolbar re-renders.
    observePageMenuSlot(event: ContentReadyEvent): void {
        const slot = event.element.querySelector(
            '.dx-toolbar-center .dx-toolbar-item-content',
        );
        this.slotObserver.disconnect();
        if (slot) {
            this.slotObserver.observe(slot);
        }
    }

    @Output()
    menuToggle = new EventEmitter<boolean>();

    @Input()
    menuToggleEnabled = false;

    @Input()
    title!: string;

    packageInfo = packageInfo;

    userMenuItems = [
        // {
        // text: 'Profile',
        // icon: 'user'
        // },
        {
            text: 'Logout',
            icon: 'runner',
            onClick: () => {
                this.authService.logOut();
            },
        },
    ];

    toggleMenu = () => {
        this.menuToggle.emit();
    };

    ngOnDestroy(): void {
        this.slotObserver.disconnect();
    }
}
